import React from "react";
import { useScrollReveal } from "../../hooks/useScrollReveal";

/**
 * How far the content sits below its resting place before it reveals.
 * Spelled out rather than interpolated so Tailwind keeps both classes.
 */
const DISTANCE_CLASS = {
  6: "translate-y-6",
  8: "translate-y-8",
} as const;

interface AnimateInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  /** Rise distance in Tailwind spacing units. */
  distance?: keyof typeof DISTANCE_CLASS;
}

/**
 * Fades and rises its children into place the first time they scroll
 * into view. Shared by the landing page and the Help & Guide page.
 */
export default function AnimateIn({
  children,
  className = "",
  delay = 0,
  distance = 8,
}: AnimateInProps) {
  const { ref, isRevealed } = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        isRevealed
          ? "opacity-100 translate-y-0"
          : `opacity-0 ${DISTANCE_CLASS[distance]}`
      } ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}
